import { ReactNode } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import clsx from 'clsx';

export type StepMetrics = {
  queued?: number;
  completed?: number;
  errored?: number;
};

type StepCardHeaderProps = {
  stepNumber: number;
  collapsed: boolean;
  onToggle: () => void;
  title?: ReactNode;
  icon?: ReactNode;
  metrics?: StepMetrics;
  actions?: ReactNode;
};

export function StepCardHeader({
  stepNumber,
  collapsed,
  onToggle,
  title,
  icon,
  metrics,
  actions,
}: StepCardHeaderProps) {
  return (
    <div
      className="grid grid-cols-[auto_1fr_auto] items-stretch border-b bg-neutral-0 rounded-t-2xl select-none border-neutral-200"
      aria-expanded={!collapsed}
    >
      <div className="h-full aspect-square flex items-center justify-center border-r border-neutral-200">
        <p className="text-md font-medium">{stepNumber}</p>
      </div>

      <div className="flex items-center px-4 py-3">
        {icon && <div className="mr-2">{icon}</div>}
        <div className="mr-1">{title}</div>
      </div>

      <div className="flex items-center gap-3 px-8 py-3 text-sm">
        <div className="hidden sm:flex items-center gap-4">
          {metrics && (
            <>
              <span className="tabular-nums">
                {metrics.queued ?? '-'} Queued
              </span>
              <span className="tabular-nums">
                {metrics.completed ?? '-'} Completed
              </span>
              <span className="tabular-nums">
                {metrics.errored ?? '-'} Errored
              </span>
            </>
          )}
        </div>
        <div className="hidden sm:block h-[90%] w-px bg-neutral-200 mx-3" />
        {actions}
        <button
          type="button"
          onClick={onToggle}
          aria-label="Toggle section"
          className="ml-1"
        >
          <CaretDown
            className={clsx(
              'h-5 w-5 transition-transform',
              !collapsed && 'rotate-180',
            )}
            weight="bold"
          />
        </button>
      </div>
    </div>
  );
}

export default StepCardHeader;
